import { LexicalNode } from "lexical";

const ALLOWED_ATTRIBUTES = new Set
([
    'class', 'id', 'style', 'srcset', 'sizes', 'loading', 'decoding',
    'referrerpolicy', 'crossorigin', 'usemap', 'ismap'
]);

export function getAttributes(domNode: Element, attrs: Record<string, string>, allowed: Set<string> = ALLOWED_ATTRIBUTES): void
{
    for (const { name, value } of Array.from(domNode.attributes))
    {
        const lower = name.toLowerCase();
        if (lower.startsWith('on')) { continue; }
        if (lower.startsWith('data-') || lower.startsWith('aria-') || allowed.has(lower))
        {
            // Avoid duplicating core props captured above
            if (['src', 'alt', 'title', 'width', 'height'].includes(lower)) { continue; }
            attrs[name] = value;
        }
    }
}

export function setAttributes(domNode: Element, attrs: Record<string, string>, exclude: Set<string> = new Set()): void
{
    for (const [name, value] of Object.entries(attrs))
    {
        if (value == null || value === '') { continue; }
        if (exclude.has(name.toLowerCase())) { continue; }
        domNode.setAttribute(name, value);
    }
}

export function $findParent<T extends LexicalNode>
(
    node: LexicalNode | null | undefined,
    predicate: (node: LexicalNode) => node is T
)
: T | null
{
    let current: LexicalNode | null | undefined = node;
    while (current)
    {
        if (predicate(current)) { return current; }
        current = current.getParent();
    }
    return null;
}